import { ROLE_FOODSBY_ADMIN } from '../../../redux/modules/user'
import { teamRoute } from '../../../routes/routes'
import menuItems from './menuItems'

const FOODSBY_ONE_AUTHORITIES = ['ROLE_ACCOUNTS_READ', 'ROLE_FOODSBY_ACCOUNTS_READ']
const isAdmin = (authorities = []) => authorities.includes(ROLE_FOODSBY_ADMIN)
const hasFoodsbyOne = authorities =>
  authorities && authorities.some(auth => FOODSBY_ONE_AUTHORITIES.includes(auth))
const isTeamManager = userTeam => userTeam?.team?.manager
const hasTeam = userTeam => Boolean(userTeam?.team)

const getMenuSections = (currentUser, userTeam, isTeamsSupported) => {
  let menuSections = {
    orderingSection: {
      title: 'Ordering',
      items: menuItems.orderingMenu,
    },
  }

  if (hasFoodsbyOne(currentUser.authorities)) {
    menuSections = {
      ...menuSections,
      foodsbyOneSection: {
        title: 'Foodsby One',
        items: menuItems.foodsbyOne,
      },
    }
  }

  const hideTeams = hasTeam(userTeam) && !isTeamManager(userTeam)
  if (isTeamsSupported && !hideTeams) {
    menuSections = {
      ...menuSections,
      teamSection: {
        title: 'Teams',
        items:
          hasTeam(userTeam) && isTeamManager(userTeam)
            ? [{ copy: userTeam.team.name, href: teamRoute.path }]
            : menuItems.teamsMenu,
      },
    }
  }

  if (isAdmin(currentUser.authorities)) {
    menuSections = {
      ...menuSections,
      adminSection: {
        title: 'Admin',
        items: menuItems.adminMenu,
      },
    }
  }

  menuSections = { ...menuSections, bottomSection: { title: '', items: menuItems.logout } }

  return menuSections
}

export default getMenuSections
